import { WebrtcStatus, StreamStatus } from './types'

// types
import { PlayerConfigProps } from './types'

export interface StateProps {
  playerConfig: PlayerConfigProps | null
  webrtcStatus: WebrtcStatus
  webrtcMessage: string | boolean
  streamStatus: StreamStatus
  streamMessage: string | boolean
  freezeFrame: boolean
}

export const initialState: StateProps = {
  playerConfig: null,
  webrtcStatus: null,
  webrtcMessage: false,
  streamStatus: null,
  streamMessage: false,
  freezeFrame: false,
}